import { CheckNgWordsService } from './../../kymw02/check-ng-words/api-services/check-ng-words.service';
import { GetTextInfoService } from './api-services/get-text-info.service';
import { RegistTextInfoService } from './api-services/regist-text-info.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjChartModule } from '@grapecity/wijmo.angular2.chart';
import { KYMW0700Component } from './kymw0700.component';

/**
 * 文字情報選択画面 モジュール設定クラス
 *
 * @export KYMW0700Module
 * @class KYMW0700Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    WjInputModule,
    WjChartModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW0700Component,
  ],
  providers: [
    GetTextInfoService,
    RegistTextInfoService,
    CheckNgWordsService
  ],
})
export class KYMW0700Module {

}
